module.exports = __webpack_public_path__ + "static/media/5_r_gazil_66.88_67.87.e85b7a2a.png";